<template>
  <div class="chart-toggles">
    <a href="#monthly" @click.prevent="setTimeRange('monthly')" :class="{'active': monthlyRange}">
      {{ $t('Monthly') }}
    </a>
    <a href="#annual" @click.prevent="setTimeRange('annual')" :class="{'active': annualRange}">
      {{ $t('Annual') }}
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChartToggles',
  props: [],
  components: {},
  computed: {
    ...mapState(['snowfallChartSettings']),
    monthlyRange() {
      return this.snowfallChartSettings.snowfallTimeRange == 'monthly';
    },
    annualRange() {
      return this.snowfallChartSettings.snowfallTimeRange == 'annual';
    },
  },
  methods: {
    setTimeRange(setting) {
      this.$store.dispatch('setSnowfallTimeRange', setting);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-toggles {
  font-family: $base-font-regular;
  font-size: 12px;
  line-height: 1;
  margin-top: 5px;
  a {
    color: $dark-gray;
    display: inline-block;
    margin-right: 10px;
    text-transform: uppercase;
    &.active {
      color: $toggles-text-color;
      font-family: $base-font-bold;
      font-weight: $toggle-selected-font-weight;
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Monthly": "Mensuelles",
  "Annual": "Annuelles"
}
</i18n>
